import { signalStore } from '@ngrx/signals';
import { withSigningInviteReducer } from './with-signing-invite.reducer';
import { withSigningInviteEffects } from './with-signing-invite.effects';

/** Public signing-invite store — provide at the `/sign` route (ADR-011), never root: the flow is
 * one ephemeral token's lifecycle and must not outlive the page that presented it. */
export const SigningInviteStore = signalStore(
  withSigningInviteReducer(),
  withSigningInviteEffects(),
);
